import { z } from "zod";

export const DeleteRoleResponseSchema = z.object({
    code: z.number(),
    message: z.string(),
    success: z.boolean(),
    data: z.nullable(z.any()),
});

export type DeleteRoleResponse = z.infer<typeof DeleteRoleResponseSchema>;